import React from "react"
import { Card, FormGroup, Input, Badge } from "reactstrap"
import { X, Search, ChevronUp, ChevronDown } from "react-feather"
import PerfectScrollbar from "react-perfect-scrollbar"
import { connect } from "react-redux"
import { ChatSocketContext } from "../../Networking/chatSocketContext";

class ChatSidebar extends React.Component {
  state = {
    value: "",
  }

  handleOnChange = e => {
    this.setState({ value: e.target.value })
    this.context.searchContacts(e.target.value)
  }

  render() {
    const { contacts, chatsContacts, chats } = this.context
    const { value } = this.state;

    const contactsArr = value.length
      ? this.context.filteredContacts
      : contacts
    const chatsArr = value.length
      ? this.context.filteredChats
      : chatsContacts
    let renderContacts =
      contactsArr.length > 0
        ? contactsArr.map((contact, index) => {
          if (contact.uid === this.props.clinicUserinfo.id) {
            return (<></>)
          }
          if (chatsContacts.find(cc => cc.uid == contact.uid)) {
            return (<></>)
          }
          return (
            <li
              key={index}
              onClick={() => {
                this.props.handleActiveChat(
                  contact.uid,
                  contact,
                  chats[contact.uid]
                )
                this.context.markSeenAllMessages(contact.uid)
                // this.props.mainSidebar(false)
              }}
              className={`${this.props.activeChatID === contact.uid ? "active" : ""
                }`}
            >
              <div className="pr-1">
                <span className="avatar avatar-md m-0">
                  <img
                    src={contact.photoURL}
                    alt={contact.displayName}
                    height="44"
                    width="44"
                  />
                </span>
              </div>
              <div className="user-chat-info">
                <div className="contact-info">
                  <h5 className="text-bold-600 mb-0">{contact.displayName}</h5>
                  <p className="truncate">{contact.about}</p>
                </div>
              </div>
            </li>
          )
        }
        )
        : null
    let renderChats =
      chatsArr && Array.isArray(chatsArr)
        ? chatsArr.map(chat => {
          let lastMsg =
            chats[chat.uid] && chats[chat.uid].msg
              ? chats[chat.uid].msg.slice(-1)[0]
              : null,
            lastMsgDate = new Date(
              lastMsg && lastMsg.time ? lastMsg.time : null
            ),
            lastMsgMonth = lastMsgDate.toLocaleString("default", {
              month: "short"
            }),
            lastMsgDay = lastMsgDate.getDate()
          let pendingMsg =
            chats[chat.uid] && chats[chat.uid].msg
              ? chats[chat.uid].msg.filter(
                i => new Date(i.time) > new Date(chats[chat.uid].lastRead) && i.isSent !== true
              ).length
              : null
          let activeID =
            chats[chat.uid] !== undefined ? chats[chat.uid] : null
          return (
            <li
              key={chat.uid}
              onClick={() => {
                this.context.checkInitialMessages(chat.uid);
                this.props.handleActiveChat(chat.uid, chat, activeID)
                // this.props.mainSidebar(false)
                this.context.markSeenAllMessages(chat.uid)
              }}
              className={`${this.props.activeChatID === chat.uid ? "active" : ""
                }`}
            >
              <div className="pr-1">
                <span className="avatar avatar-md m-0">
                  <img
                    src={chat.photoURL}
                    alt={chat.displayName}
                    height="44"
                    width="44"
                  />
                </span>
              </div>
              <div className="user-chat-info">
                <div className="contact-info">
                  <h5 className="text-bold-600 mb-0">{chat.displayName}</h5>
                  <p className="truncate">
                    {lastMsg ? lastMsg.textContent : chat.about}
                  </p>
                </div>
                <div className="contact-meta d-flex- flex-column">
                  <span className="float-right mb-25">
                    {lastMsgMonth + " " + lastMsgDay}
                  </span>
                  {pendingMsg > 0 ? (
                    <div className="unseen-msg">
                      <Badge
                        style={{ width: 16, height: 16, color: 'transparent' }}
                        pill
                        className="badge-md float-right"
                        color="primary"
                      >
                        .
                      </Badge>
                    </div>
                  ) : null}
                </div>
              </div>
            </li>
          )
        })
        : null
    return (
      <Card
        role={(this.props.isMini && !this.props.isOpened) && "button"}
        onClick={() => {
          if (!this.props?.isOpened && this.props?.isMini) {
            this.props.toggleOpened()
          }
        }}
        className={"sidebar-content " + (this.props?.isMini ? "mini-chat " : " h-100")}>
        <span
          className="sidebar-close-icon"
        // onClick={() => this.props.mainSidebar(false)}
        >
          <X size={15} />
        </span>
        <div className="chat-fixed-search" style={{ backgroundColor: (this.props.isMini && !this.props.isOpened) ? '#fa9d1d' : '', justifyContent: 'space-between', flexDirection: 'row', display: 'flex', alignItems: 'center' }}>
          <div className="d-flex align-items-center">
            <div className="sidebar-profile-toggle position-relative d-inline-flex">
              <div
                className="avatar"
              >
                <img src={this.props.clinicUserinfo.profileImagePath} alt="User Profile" height="44" width="44" />
                {/* <span
                  className={
                    status === "dnd"
                      ? "avatar-status-busy"
                      : status === "away"
                        ? "avatar-status-away"
                        : status === "offline"
                          ? "avatar-status-offline"
                          : "avatar-status-online"
                  }
                /> */}
              </div>
            </div>
            {(this.props.isOpened || !this.props.isMini) ?
              <FormGroup className="position-relative has-icon-left mx-1 my-0 w-100">
                <Input
                  className="round"
                  type="text"
                  placeholder="Kişileri Arayın..."
                  onChange={e => this.handleOnChange(e)}
                  value={value}
                />
                <div className="form-control-position">
                  <Search size={15} />
                </div>
              </FormGroup>
              :
              <span style={{ fontSize: 18, marginLeft: 8, color: 'white', fontWeight: '700' }}>{'Mesajlar'}</span>
            }
          </div>

          {this.props.isMini &&
            <span role="button" className="mr-2" onClick={() => {
              if (this.props.isOpened) {
                this.props.toggleOpened()
              }
            }}>
              {this.props.isOpened ?
                <ChevronDown />
                :
                <ChevronUp color="white"/>
              }
            </span>
          }
        </div>


        <PerfectScrollbar
          className="chat-user-list list-group"
          options={{
            suppressScrollX: true,
            wheelPropagation: false
          }}
        >
          <h3 className="primary p-1 mb-0">Mesajlar</h3>
          <ul className="chat-users-list-wrapper media-list">{renderChats}</ul>
          <h3 className="primary p-1 mb-0">Kişiler</h3>
          <ul className="chat-users-list-wrapper media-list">
            {renderContacts}
          </ul>
        </PerfectScrollbar>
      </Card>
    )
  }
}

ChatSidebar.contextType = ChatSocketContext;
const mapStateToProps = state => {
  return {
    clinicUserinfo: state.clinicUser.clinicUserinfo
  }
}
export default connect(mapStateToProps, {})(ChatSidebar)
